import * as React from "react";
const SvgFiRrRibbon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ribbon_svg__a)">
      <path
        fill="#062147"
        d="m21.07 17.859-3.823-3.811.404-.405c3.116-3.116 3.116-8.187 0-11.303A7.94 7.94 0 0 0 12-.001 7.96 7.96 0 0 0 6.491 2.2C4.98 3.638 4.134 5.622 4.107 7.786a8.47 8.47 0 0 0 2.452 6.067l.114.115-3.786 3.821a2.98 2.98 0 0 0-.888 2.122c-.002.804.31 1.561.879 2.13l1.1 1.1a3 3 0 0 0 2.119.877c.767 0 1.541-.294 2.13-.882l3.769-3.826 3.797 3.81a3 3 0 0 0 2.122.874 3 3 0 0 0 2.09-.844l1.041-1.012a2.97 2.97 0 0 0 .91-2.137 2.98 2.98 0 0 0-.886-2.144zm-3.078-9.867a5.95 5.95 0 0 1-1.756 4.237l-.406.406-2.336-2.329C14.828 9.157 17 6.983 17 4.999q0-.167-.011-.331a5.95 5.95 0 0 1 1.003 3.324M12 2c1.654 0 3 1.346 3 3 0 1.024-1.599 2.769-3 3.95C10.599 7.768 9 6.024 9 5c0-1.654 1.346-3 3-3M6.808 21.728a1 1 0 0 1-1.415 0l-1.099-1.1A1 1 0 0 1 4 19.917a1 1 0 0 1 .302-.713l3.784-3.818 2.498 2.507-3.776 3.834zm12.845-1.022-1.041 1.012a1.003 1.003 0 0 1-1.403-.009l-9.234-9.268a6.46 6.46 0 0 1-1.867-4.629 5.9 5.9 0 0 1 .902-3.114q-.009.15-.009.302c0 2.524 3.516 5.357 4.349 5.992l8.311 8.285c.192.19.297.444.296.716a.99.99 0 0 1-.304.713"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ribbon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRibbon;
